import { createFileRoute } from "@tanstack/react-router"
import { DeviceManagement } from "@/components/sensory"
import { SecurityVerifier } from "@/security/routeSecurityVerifier"

export const Route = createFileRoute("/sensory/device-management/")({
  staticData: {
    title: 'Device Management',
    isSecured: true,
  },
  beforeLoad: (ctx) => {
    SecurityVerifier(ctx, { isSecured: true })
  },
  component: DeviceManagementPage,
})

function DeviceManagementPage() {
  return (
    <div className="p-6">
      <DeviceManagement />
    </div>
  )
}
